<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/WkXrY3/tc-custom/9781504021524.jpg?1726617321309" alt="This image is the cover for the book Wizard's Hall"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wizard's Hall
      </h1>
      <p class="bookDescription body article font2">
        <b>An inept wizard-in-training is the only one who can save his classmates from the terrible sorcery that threatens to devour their magical school</b><br/><br/> Acclaimed master fantasist Jane Yolen imagines an academic world of wonders where paintings speak, walls move, monsters are made real, and absolutely <i>anything</i> can happen—as she introduces readers to a hero as hapless as the legendary Merlin is powerful.<br/>  <br/> It was Henry’s dear ma who decided to send him off to Wizard’s Hall to study sorcery, despite the boy’s apparent lack of magical talent. He has barely stepped through the gates of the magnificent school when he is dubbed Thornmallow (“prickly on the outside, squishy within”). Still, regardless of his penchant for turning even the simplest spell into a disaster, Thornmallow’s teachers remain kind and patient, and he soon has a cadre of loyal, loving friends. But there is something that no one is telling the boy: As the 113th student to enroll in the wondrous academy, Thornmallow has an awesome and frightening duty to fulfill—and failure will mean the destruction of Wizard’s Hall and everyone within its walls.<br/><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Yolen
      </h2>
      
      <p class="authorDescription body article">&amp;lt;p&amp;gt;&amp;lt;strong&amp;gt;Jane Yolen&amp;lt;/strong&amp;gt; is a highly acclaimed author who has written hundreds of books for children and adults and has won numerous awards. She and her husband divide their time between Massachussetts and Scotland.&amp;lt;/p&amp;gt;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55f9876c